type PushNotificationTokenValues = {
  offeringName?: string;
  firstName?: string;
};

const resolvePushNotificationTokens = (body: string | undefined, { offeringName, firstName }: PushNotificationTokenValues) => {
  const tokenValues: Record<string, string> = {
    '[OFFERING_NAME]': offeringName ?? '',
    '[FIRST_NAME]': firstName ?? '',
  };

  return (body ?? '').replace(/\[OFFERING_NAME\]|\[FIRST_NAME\]/g, (token) => tokenValues[token]);
};

export default resolvePushNotificationTokens;
